export const campServiceTypeDashboardTranslations = {
    en: {
        loading: "Loading Dashboard...",
        serviceTypes: "Service Types",
        serviceTypesSubtitle: "How many people received each type of help",
        serviceDetails: "Service Details at a Glance",
        serviceDetailsSubtitle: "Detailed overview of each service",
        spectaclePending: "Spectacle Pending",
        spectacleDispatched: "Spectacle Dispatched",
        spectacleDelivered: "Spectacle Delivered",
        surgeryPending: "Surgery Pending",
        surgeryScheduled: "Surgery Scheduled",
        surgeryDone: "Surgery Done",
        diagnosticPending: "Diagnostic Pending",
        diagnosticScheduled: "Diagnostic Scheduled",
        diagnosticDone: "Diagnostic Done",
    },
    mr: {
        loading: "डॅशबोर्ड लोड होत आहे...",
        serviceTypes: "सेवांचा प्रकार",
        serviceTypesSubtitle: "कोणत्या प्रकारची मदत किती लोकांना मिळाली",
        serviceDetails: "सेवा तपशील: एक दृष्टीक्षेपात",
        serviceDetailsSubtitle: "प्रत्येक सेवेचा तपशीलवार आढावा",
        spectaclePending: "चष्मे प्रलंबित",
        spectacleDispatched: "चष्मे पाठवले",
        spectacleDelivered: "चष्मे वितरित",
        surgeryPending: "शस्त्रक्रिया प्रलंबित",
        surgeryScheduled: "शस्त्रक्रिया नियोजित",
        surgeryDone: "शस्त्रक्रिया पूर्ण",
        diagnosticPending: "निदान प्रलंबित",
        diagnosticScheduled: "निदान नियोजित",
        diagnosticDone: "निदान पूर्ण",
    },
};
